import { render, staticRenderFns } from "./NeedCard.vue?vue&type=template&id=538a6598&"
import script from "./NeedCard.vue?vue&type=script&lang=js&"
export * from "./NeedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedCard.vue"
export default component.exports